import React, { useCallback, useEffect, useState } from 'react';
import {
  TextField, SelectField, GetCountries, GetContinents,
} from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';
import { RuleActionTypes } from '../../Security.types';

const SelectInput = ({
  placeholder,
  value,
  handleOnSelectChange,
  options,
}) => (
  <SelectField
    size="md"
    placeholder={placeholder}
    value={value}
    setValue={label => handleOnSelectChange(label)}
    options={options}
    withScroll
    positionAbsolute
    testId="cloudflare-rule-value__select"
  />
);

const TextFieldInput = ({
  label, ruleValue, handleOnTextChange, mask,
}) => (
  <TextField
    label={label}
    value={ruleValue}
    onChange={e => handleOnTextChange(e.target.value)}
    inputHeight={60}
    mask={mask}
    testId="cloudflare-rule-value__textfield"
  />
);

const BlockRuleInput = ({
  selectedLockType,
  ruleValue,
  setRuleValue,
  locales,
}) => {
  const [selectedOptionLabel, setSelectedOptionLabel] = useState('');

  const continents = GetContinents({
    lang: isBRServer ? 'br' : 'es',
  });

  const countries = GetCountries({
    lang: isBRServer ? 'br' : 'es',
  });

  const continentsOptions = continents.map(continent => ({
    value: continent.id,
    label: continent.name,
  }));

  const countriesOptions = countries.map(country => ({
    value: country.id,
    label: country.name,
  }));

  const handleOnTextChange = (value) => {
    setRuleValue && setRuleValue(value);
  };

  const handleOnSelectChange = (selectedOptionLabel) => {
    const getSelectedCountry = () => countriesOptions.find(country => country.label === selectedOptionLabel);
    const getSelectedContinent = () => continentsOptions.find(continent => continent.label === selectedOptionLabel);

    const selectedOption = selectedLockType === 'country' ? getSelectedCountry() : getSelectedContinent();
    setSelectedOptionLabel && setSelectedOptionLabel(selectedOptionLabel);
    setRuleValue && setRuleValue(selectedOption.value);
  };

  const getSelectCountryProps = () => ({
    placeholder: locales.ruleTypes[RuleActionTypes.COUNTRY].ruleValuePlaceholder,
    value: selectedOptionLabel,
    handleOnSelectChange,
    options: countriesOptions,
  });

  const getSelectContinentProps = () => ({
    placeholder: locales.ruleTypes[RuleActionTypes.CONTINENT].ruleValuePlaceholder,
    value: selectedOptionLabel,
    handleOnSelectChange,
    options: continentsOptions,
  });

  const getInputUrlProps = () => ({
    label: locales.ruleTypes[RuleActionTypes.URL].ruleValuePlaceholder,
    ruleValue,
    handleOnTextChange,
  });

  const getInputIpAddressProps = () => ({
    label: locales.ruleTypes[RuleActionTypes.SOURCE_IP_ADDRESS].ruleValuePlaceholder,
    ruleValue,
    handleOnTextChange,
    mask: 'ip',
  });

  const setInitialValue = useCallback(() => {
    if (ruleValue) {
      const getSelectedCountry = () => countriesOptions.find(country => country.value === ruleValue);
      const getSelectedContinent = () => continentsOptions.find(continent => continent.value === ruleValue);

      const selectedOption = selectedLockType === 'country' ? getSelectedCountry() : getSelectedContinent();
      return selectedOption && setSelectedOptionLabel(selectedOption.label);
    }
    setSelectedOptionLabel('');
  }, [selectedLockType, countriesOptions, continentsOptions, ruleValue]);

  useEffect(() => {
    setInitialValue();
  }, [setInitialValue]);

  const componentByRule = {
    [RuleActionTypes.COUNTRY]: <SelectInput {...getSelectCountryProps()} />,
    [RuleActionTypes.CONTINENT]: <SelectInput {...getSelectContinentProps()} />,
    [RuleActionTypes.URL]: <TextFieldInput {...getInputUrlProps()} />,
    [RuleActionTypes.SOURCE_IP_ADDRESS]: <TextFieldInput {...getInputIpAddressProps()} />,
  };

  return selectedLockType ? componentByRule[selectedLockType] : <></>;
};

export default BlockRuleInput;
